import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "placeholder-glow" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "placeholder bg-primary col-8" })
], -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.nCols, (n) => {
      return (_openBlock(), _createElementBlock("td", { key: n }, _hoisted_2))
    }), 128))
  ]))
}